import type { SkillVerdict } from './types';

/** Canonicalise a skill string for identity comparisons + verdict-cache keys (shared with `JobSignalPanel`). */
export const normalize = (s: string): string =>
  s.trim().toLowerCase().replace(/\s+/g, ' ');

/**
 * What to render on a skill chip. Prefer the vocabulary's served `display` casing (`.net` → `.NET`) when present
 * (plan 9.8); otherwise fall back to the recruiter's own typed casing when it matches the canonical (it's their
 * entry), else the raw canonical (a suggestion / normalisation with no served casing) — never a hand-rolled
 * acronym/title-case guess.
 */
export function displayLabel(v: SkillVerdict): string {
  if (v.display) return v.display;
  if (normalize(v.input) === normalize(v.canonical)) return v.input.trim();
  return v.canonical;
}
